import { render, staticRenderFns } from "./GovernmentNicheIcon.vue?vue&type=template&id=de30da38&scoped=true"
import script from "./GovernmentNicheIcon.vue?vue&type=script&lang=js"
export * from "./GovernmentNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de30da38",
  null
  
)

export default component.exports